import {API_URL} from 'api/constants'
export const ITEMS_EXPORT = `${API_URL}/v1/items/import_items_template`
export const ITEM_DOWNLOAD_TEMPLATE = `ITEM_DOWNLOAD_TEMPLATE`
export const LIST_ITEM_URL = `${API_URL}/v1/items`
export const ITEM_SUMMARY_URL = `${API_URL}/v1/items/summary`
export const ITEMS_TEMPLATE = `${API_URL}/v1/items/import_items_template`
export const ITEM_BY_ID = (id) => (`${LIST_ITEM_URL}/${id}`)
export const CREATE_ITEM = `${API_URL}/v1/items`
export const CREATE_ALL_OUTLET_ITEM = `${API_URL}/v1/items/create_all_outlet`
export const UPDATE_ITEM_BY_ID = (id) => (`${ITEM_BY_ID(id)}/update_image`)
export const DELETE_ITEM_BY_ID_V1 = (id) => (`${ITEM_BY_ID(id)}`)
export const GET_NEW_ITEM_V1 = `${LIST_ITEM_URL}/new`



// WEBPACK FOOTER //
// ./app/api/libraries/items/constants.js